module.exports = __webpack_public_path__ + "img/sesame.11759868.svg";